export class ExpiredTokenError extends Error {
    name = "ExpiredTokenError";

    constructor() {
        super("token is expired");
    }
}
